export const RECAPTCHA_SITE_KEY = process.env?.REACT_APP_API_RECAPTCHA || "";
export const BASE_URL_MIDDLEWARE = process.env?.REACT_APP_API_MIDDLEWARE || "";
